import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadge } from '@fortawesome/pro-regular-svg-icons';

import './index.css';

function RemoveButton(props) {
    const { t } = useTranslation('tvplan');

    return (
    	<Button
            danger
            icon={<FontAwesomeIcon className='add-button-icon' icon={faBadge} />}
            onClick={props.onClick}>{t('Remove').toUpperCase()}</Button>
    );
}

export default RemoveButton;